module.exports = __webpack_public_path__ + "img/parcel.bdf28ae0.png";